<template>
  <div>
    <vx-card titleIcon="SearchIcon" ref="filterCard" title="Audit Log Summary" class="user-list-filters mb-8" :collapse-action="true">
     <SundryItemAuditStockLogSummary/>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUNDRY ITEMS">
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
              class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="sundry-item-list-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="items" sort
              :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="sundry_item_code">ITEM CODE</vs-th>
                <vs-th width="20%" sort-key="sundry_product_code">PRODUCT CODE</vs-th>
                <vs-th width="20%">PRODUCT NAME</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickViewStock(data[indextr].id)" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].sundry_item_code">
                    {{ data[indextr].sundry_item_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_code">
                    {{ data[indextr].sundry_product_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_name">
                    {{ data[indextr].sundry_product_name }}
                  </vs-td>

                  <vs-td>
                    <vs-chip transparent :color="sundryItemStatusColorFactory(data[indextr].status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View Log" position="left">
                        <vs-button @click.stop="onClickViewStock(data[indextr].id)" size="small" color="primary"
                          type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const SundrySuppliersRepository = RepositoryFactory.get('sundry')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";
import SundryItemAuditStockLogSummary from './SundryItemAuditStockLogSummary.vue';


export default {
  name: 'SundryItemList',
  data() {
    return {
      items: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    'v-select': vSelect,
    SundryItemAuditStockLogSummary
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  methods: {
    async refreshData() {
      this.fetchSundryItems()
    },
    async fetchSundryItems() {
      await this.$vs.loading({
        container: '#sundry-item-list-table',
        scale: 0.45
      })
      try {
        const { data } = await SundrySuppliersRepository.getListOfSystemSundryItems(this.page, this.filterQuery, this.perPage, this.sort)
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
    },

    async onClickViewStock(id) {
      this.$router.push(`/pages/activity-logs/sundry-stock-adjust/${id}/sundry-batch`)
    },
    filterQueryUpdate() {
      this.fetchSundryItems()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchSundryItems()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryItems()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    sundryItemStatusColorFactory(id) {
      switch (id) {
        case 1:
          return 'warning';
        case 2:
          return 'primary';
        case 3:
          return 'danger';
        case 4:
          return 'warning';
      }
    },
  },
  watch: {
    page() {
      this.fetchSundryItems()
    },
    perPage() {
      this.fetchSundryItems()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
